import React, { Component } from 'react';
import "LIBRARY/Components/ResourceDetails/importBulkUpdateResources.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import CSVReader from 'react-csv-reader'
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import { toast } from 'react-toastify';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import Select from 'react-select';
import { Base64 } from 'js-base64';
import * as XLSX from "xlsx";

const papaparseOptions = {}
let resourceConditionData = [];
let resourceLanguageData = [];
let resourceTypeData = [];
let locationSubLocationData = [];
let categorySubCategoryData = [];
let multipleSelectOption = [];

class ImportBulkUpdateResources extends Component {
    constructor(props) {
        super(props)
        this.tableObject = {};
        this.myRef = React.createRef();
        this.state = {
            importUpdateResourceModal: false,
            tabs: [
                { name: "Choose Excel File" },
                { name: "Start Import" }
            ],
            currentTab: 0,

            csvData: [],
            updateResourceDetailsArray: [],
            updateResourceHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                errors: [],
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
                verificationHistory: {}
            },

            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},
            fullScreen: false,

            errorMessageObjArray: [],
            preRequisiteFileName: 'Prerequisite Data.csv',


            //PreRequisite data
            preRequisiteCSVDataForResources: [
                { accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: '', department: '', resourceType: '', location: '', resourceCondition: '', invoiceNo: '', resourceStatus: '' },
            ],

            preRequisiteData: [],

            loadingPurchaseOrderData: false,

            preRequisiteCSVHeadersForResources: [
                { label: "Accession Series", key: "accessionSeries" },
                { label: "Resource Language", key: "resourceLanguage" },
                { label: "Publisher", key: "publisher" },
                { label: "Resource Category", key: "resourceCategory" },
                { label: "Department (Stream)", key: "department" },
                { label: "Resource Type", key: "resourceType" },
                { label: "Location", key: "location" },
                { label: "Resource Condition", key: "resourceCondition" },
                { label: "Invoice Bill Number", key: "invoiceNo" },
                { label: "Resource Status", key: "resourceStatus" },
            ],

            preRequisiteHeaders: [],
            verifyImportResourceResult: [],  // set response of import update resource 
            loadingImportResourceProcess: false,

            isImportButtonDisabled: false,
            resourceMultipleDetailsData: [],

            isValidAttachment: true,
        }
    }

    componentDidMount() {
        this.setState({
            importUpdateResourceModal: this.props.openBulkUpdateResourceModal,
            isImportButtonDisabled: false,
            resourceMultipleDetailsData: this.props.multipleResourcesDetails
        })

        let preRequisiteData = this.state.preRequisiteCSVDataForResources
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForResources
        let streamData = this.props.streamListData
        let accessionSeriesData = this.props.accessionSeriesListData
        let locationData = this.props.locationListData
        let resourceCategoryData = this.props.resourceCategoryData
        let publisherData = this.props.publisherData
        let resourceStatusData = this.props.resourceStatusData
        let invoiceDetailsData = this.props.invoiceData

        // custom location and sub-location data list
        locationSubLocationData = locationData.flatMap(item => [
            { value: item.value, name: item.name },
            ...item?.sublocations.map(sublocation => ({
                value: sublocation.sublocationId,
                name: sublocation.sublocationName
            }))
        ]);

        // custom category and sub-category data list
        categorySubCategoryData = resourceCategoryData.flatMap(item => [
            { value: item.value, name: item.name },
            ...item?.subCategories.map(subCategory => ({
                value: subCategory.subCategoryId,
                name: subCategory.subCategoryName,
                parentId: subCategory.parentId
            }))
        ]);

        resourceConditionData = ["Good", "Partially damaged", "Completely Damaged"]
        resourceLanguageData = ["English", "Marathi", "Assamese", "Bengali", "Gujarati", "Kannada", "Kashmiri", "Konkani", "Malayalam", "Manipuri", "Oriya", "Punjabi", "Hindi", "Sanskrit", "Sindhi", "Tamil", "Telugu", "Urdu"]
        resourceTypeData = [
            "Text Book",
            "Reference Book",
            "Atlas",
            "Biography",
            "Book with CD",
            "CD-ROM",
            "Floppy",
            "General",
            "Laboratory Manual",
            "Practical",
            "Practical Manual",
            " Practical Note Book",
            "Text Book(Practical)",
            "Text Book(Theory & Practical)",
            "Question Bank",
            "Project Thesis",
            "Other",
            "Book bank",
            "Bound Volume",
            "Current issue of the journals",
            "Syllabus copy",
            "Previous years question papers copy"
        ]

        // For department (stream data)
        if (Object.values(streamData).length > 0) {
            Object.values(streamData).map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].department = data?.name
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: '', department: data?.name, resourceType: '', location: '', resourceCondition: '', invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        // For accession Series Data
        if (Object.values(accessionSeriesData).length > 0) {
            Object.values(accessionSeriesData).map((data, index) => {
                if (data?.label != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].accessionSeries = data?.label
                    } else {
                        preRequisiteData.push({ accessionSeries: data?.label, resourceLanguage: '', publisher: '', resourceCategory: '', department: '', resourceType: '', location: '', resourceCondition: '', invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        // For location Data
        if (locationSubLocationData?.length > 0) {
            locationSubLocationData?.map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].location = data?.name
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: '', department: '', resourceType: '', location: data?.name, resourceCondition: '', invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        // for resource category data
        if (categorySubCategoryData.length > 0) {
            categorySubCategoryData.map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceCategory = data?.name
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: data?.name, department: '', resourceType: '', location: '', resourceCondition: '', invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        // for publisher data
        if (Object.values(publisherData).length > 0) {
            Object.values(publisherData).map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].publisher = data?.name
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: data?.name, resourceCategory: '', department: '', resourceType: '', location: '', resourceCondition: '', invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        // for resource status data
        if (Object.values(resourceStatusData).length > 0) {
            Object.values(resourceStatusData).map((data, index) => {
                if (data?.status != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceStatus = data.status ? data.status.charAt(0).toUpperCase() + data.status.slice(1) : '' // data?.status
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: '', department: '', resourceType: '', location: '', resourceCondition: '', invoiceNo: '', resourceStatus: data.status ? data.status.charAt(0).toUpperCase() + data.status.slice(1) : ''  })
                    }
                }
            })
        }

        // for invoice data
        if (Object.values(invoiceDetailsData).length > 0) {
            Object.values(invoiceDetailsData).map((data, index) => {
                if (data?.billno != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].invoiceNo = data?.billno
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: '', department: '', resourceType: '', location: '', resourceCondition: '', invoiceNo: data?.billno, resourceStatus: '' })
                    }
                }
            })
        }

        // for resource condition data
        if (resourceConditionData.length > 0) {
            resourceConditionData.map((data, index) => {
                if (data != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceCondition = data
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: '', department: '', resourceType: '', location: '', resourceCondition: data, invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        // for resource language data
        if (resourceLanguageData.length > 0) {
            resourceLanguageData.map((data, index) => {
                if (data != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceLanguage = data
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: data, publisher: '', resourceCategory: '', department: '', resourceType: '', location: '', resourceCondition: '', invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        // for resource type data
        if (resourceTypeData.length > 0) {
            resourceTypeData.map((data, index) => {
                if (data != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceType = data
                    } else {
                        preRequisiteData.push({ accessionSeries: '', resourceLanguage: '', publisher: '', resourceCategory: '', department: '', resourceType: data, location: '', resourceCondition: '', invoiceNo: '', resourceStatus: '' })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })

    }

    // // Import INVOICE Modal Start From Here
    // openImportInvoiceModal = () => {

    //     const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['invoice'].find(access => access === 'add');

    //     if (addGrantAccess !== undefined) {

    //         this.setState({
    //             importUpdateResourceModal: true,
    //             isImportButtonDisabled: false
    //         })

    //     } else {
    //         this.setState({
    //             successModal: true,
    //             successModalType: 'warning',
    //             successMessage: 'This operation is restricted by the Library admin.'
    //         });
    //     }

    // }

    closeImportResourceModal = () => {
        this.setState({
            importUpdateResourceModal: false,
            currentTab: 0,

            csvData: [],
            updateResourceDetailsArray: [],
            updateResourceHeadersArray: [],
            selectedCSVFiles: {},
            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            verifiedData: [],
            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},

        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // OPEN FILE
    openFileInput = () => {
        // document.getElementById("react-csv-reader-input").click();
        document.getElementById("react-excel-reader-input").click();
    }

    // REMOVE SELECTED CSV FILE
    removeCSVFile = () => {
        this.setState({
            selectedCSVFiles: {},
            csvData: [],
            updateResourceDetailsArray: [],
            updateResourceHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            selectedCSVFiles: {},
            verifiedData: [],
        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // Import BULK UPDATE RESOURCE Modal
    importUpdateResourceModal = () => {
        let resultFailedData = this.state.updateResourceDetailsArray.filter((item) => item.importStatus == 'failed')
        let resultSuccessData = this.state.updateResourceDetailsArray.filter((item) => item.importStatus == 'success')
        let resultPendingData = this.state.updateResourceDetailsArray.filter((item) => item.importStatus == 'pending')

        return (
            <>
                <div className={this.state.importUpdateResourceModal ? 'modal fade show' : 'modal'} style={{ display: this.state.importUpdateResourceModal ? "block" : 'none', visibility: this.state.importUpdateResourceModal ? 'visible' : 'hidden' }}>
                    <div class="modal-dialog modal-lg--userdetails modal-dialog-centered" style={{ maxWidth: this.state.fullScreen ? '100vw' : '60vw', margin: this.state.fullScreen ? "0px auto" : "auto" }}>
                        <div class="modal-content modal-dialog-scrollable modal_content">
                            <div class="modal-header modal_header">
                                <h5 class="modal-title" style={{ textAlign: 'left', fontWeight: 600 }} id="exampleModalLabel">Import to update Resource</h5>
                                {this.state.loadingImportResourceProcess || this.state.loadingImportProcess ?
                                    null :
                                    <>
                                        <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
                                            <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                this.setState({
                                                    fullScreen: !this.state.fullScreen
                                                })
                                            }}>
                                                {
                                                    this.state.fullScreen ?
                                                        (
                                                            <span>
                                                                <span style={{ border: '2px solid #000 !important', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                            </span>
                                                        ) :
                                                        (
                                                            <span>
                                                                <span style={{ border: '2px solid #000 !important', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                            </span>
                                                        )
                                                }
                                            </button>
                                            <span style={{ cursor: "pointer" }} onClick={() => {
                                                this.closeImportResourceModal()
                                            }}>
                                                <FontAwesomeIcon icon={['fas', 'times']} size={'md'} />
                                            </span>
                                        </div>
                                    </>
                                }
                            </div>
                            <div class="modal-body" style={{ maxHeight: this.state.fullScreen ? '100vh' : "80vh", height: this.state.fullScreen ? '100vh' : '80vh' }}>
                                <div className="">
                                    <div className="row">
                                        <div className="col">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="import-header">
                                                    {
                                                        this.state.tabs.map((item, index) => {
                                                            return (
                                                                <div className="tab-wrapper"><span className={this.state.currentTab == index ? "circle-tab" : "circle-tab-muted"}>{index + 1}</span><p className={this.state.currentTab == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p></div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                {/* <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                    this.setState({
                                                        fullScreen: !this.state.fullScreen
                                                    })
                                                }}>
                                                    {
                                                        this.state.fullScreen ?
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            ) :
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            )
                                                    }
                                                </button> */}
                                            </div>

                                            {
                                                this.state.currentTab == 0 && this.chooseFileComponent()
                                            }
                                            {
                                                this.state.currentTab == 1 && this.importCSVFileComponent()
                                            }

                                            <div className="import-footer">
                                                {
                                                    this.state.currentTab == 1 &&

                                                    <div style={{ width: '100%', margin: '0px 10px 0 0' }}>

                                                        {
                                                            <div className="d-flex align-items-center flex-wrap" style={{ display: this.state.loadingImportProcess ? '' : 'none !important' }}>
                                                                {
                                                                    <>
                                                                        <ProgressBar bgcolor={"#6a1b9a"} completed={this.state.importProgressSummary['completed']} failed={this.state.importProgressSummary['failed']} total={this.state.importProgressSummary['total']} pending={this.state.importProgressSummary['pending']} />
                                                                        <p className="mb-0 font-weight-bold" style={{ fontSize: 14 }}>Import Progress: {(this.state.importProgressSummary['total'] - this.state.importProgressSummary['pending'])} | {this.state.importProgressSummary['total']}</p>
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.currentTab == 0 && this.state.csvData.length > 0 && this.state.validations['isHeadersValid'] && (
                                                        <button type="button" className="btn import-btn" onClick={() => {
                                                            this.setState({
                                                                currentTab: 1
                                                            })
                                                        }}>
                                                            Proceed
                                                        </button>
                                                    )
                                                }
                                                {
                                                    this.state.currentTab == 1 && (
                                                        <>
                                                            {
                                                                this.state.validations['isVerified'] ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Verified
                                                                    </span>
                                                                    :
                                                                    resultPendingData?.length > 0 || resultFailedData?.length > 0 ?
                                                                        this.state.loadingImportProcess ? <ButtonLoader /> :
                                                                            <button type="button" className="btn import-btn" disabled={this.state.validations['isVerified']}
                                                                                onClick={() => {

                                                                                    let importProgressSummary = { completed: 0, failed: 0, total: this.state.updateResourceDetailsArray.length, pending: this.state.updateResourceDetailsArray.length }
                                                                                    this.setState({
                                                                                        loadingImportProcess: true,
                                                                                        importProgressSummary
                                                                                    }, () => {

                                                                                        this.apiCallToImportVerifyResourceDetails(0, this.state.importProgressSummary)
                                                                                    })
                                                                                }

                                                                                }
                                                                            >
                                                                                Verify
                                                                            </button>

                                                                        : null

                                                            }

                                                            {/* (resultSuccessData?.length > 0 && (resultFailedData?.length == 0 || this.state.loadingImportProcess == false)) */}
                                                            {(resultSuccessData?.length > 0 && this.state.loadingImportProcess == false && resultFailedData?.length == 0) ?
                                                                this.state.loadingImportResourceProcess ? <ButtonLoader /> :
                                                                    < button type="button" className="btn import-btn" disabled={this.state.isImportButtonDisabled} onClick={() => {
                                                                        this.setState({
                                                                            loadingImportResourceProcess: true
                                                                        }, () => {
                                                                            this.apiCallToUpdateResourceDetails(0)
                                                                        })
                                                                    }
                                                                    }>
                                                                        Import
                                                                    </button>
                                                                : null
                                                            }

                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.importUpdateResourceModal && <div className="modal-backdrop fade show"></div>}
            </>
        )
    }

    // // export multiple resource details into csv format
    // exportData = () => {
    //     // Define the CSV headers
    //     const headers = [
    //         "Accession Series*", "Accession Number*", "Accession Date", "Call Number", "Title*", "Author*",
    //         "Resource Volume", "Resource Edition", "Resource Language*", "Publisher*", "Number of Pages",
    //         "Number of Preliminary Pages", "Resource Category*", "Year of Publication", "Department",
    //         "Resource Type*", "Translator Name", "Translated", "Search Keyword", "Location",
    //         "ISBN Number", "Resource Condition", "Invoice/Bill No.", "Invoice/Bill Date",
    //         "Price", "Discount (in %)", "Net Price (in ₹ Per Copy)", "Resource Status"
    //     ];

    //     // Create the CSV string with headers
    //     let csvString = `"${headers.join('","')}"\n`;

    //     // Loop through the resourceMultipleDetailsData and generate the rows
    //     Object.keys(this.state.resourceMultipleDetailsData).forEach(key => {
    //         const resource = this.state.resourceMultipleDetailsData[key];

    //         // Define the extractValue function
    //         function extractValue(str) {
    //             // Check if '>>' is in the string
    //             if (str.includes('>>')) {
    //                 // Split the string at '>>' and get the part after it, then trim any extra spaces
    //                 let value = str.split('>>')[1];
    //                 return value; // Return the value after '>>'
    //             }
    //             return str; // If '>>' is not found, return the original string
    //         }

    //         let locationValue = resource.location_name !== "Not present" ? extractValue(resource.location_name) : "";
    //         let categoryNameValue = resource.resource_category_name ? extractValue(resource.resource_category_name) : "";
    //         let invoiceNoValue = resource.billno !== "Not present" ? resource.billno : "";
    //         let departmentNameValue = resource.stream_name !== "Not present" ? resource.stream_name : "";

    //         const row = [
    //             resource.AccessionText || '', // Accession Series
    //             resource.accessionnumber || '', // Accession Number
    //             resource.accession_date || '', // Accession Date
    //             resource.callNumber || '', // Call Number
    //             resource.title || '', // Title
    //             resource.author || '', // Author
    //             resource.volume || '', // Resource Volume
    //             resource.edition || '', // Resource Edition
    //             resource.resource_lang || '', // Resource Language
    //             resource.publishername || '', // Publisher
    //             resource.number_of_pages || '', // Number of Pages
    //             resource.preliminary_pages || '', // Number of Preliminary Pages
    //             categoryNameValue || '', // Resource Category
    //             resource.yearOfPublication || '', // Year of Publication
    //             departmentNameValue || '', // Department (could map based on `stream_name`)
    //             resource.resource_type || '', // Resource Type
    //             resource.translator || '', // Translator Name
    //             resource.transalated || '', // Translated
    //             resource.search_key_word || '', // Search Keyword
    //             locationValue || '', // Location
    //             resource.isbn_number || '', // ISBN Number
    //             resource.resource_condition || '', // Resource Condition
    //             invoiceNoValue || '', // Invoice/Bill No.
    //             resource.bill_date || '', // Invoice/Bill Date
    //             resource.price || '', // Price
    //             resource.discount || '', // Discount
    //             resource.netprice || '', // Net Price
    //             resource.resource_status || '' // Resource Status
    //         ];

    //         // Add the row to the CSV string
    //         csvString += `"${row.join('","')}"\n`;
    //     });

    //     // Trigger the download of the CSV file
    //     const downloadLink = document.createElement('a');
    //     downloadLink.download = 'resource-details.csv';
    //     downloadLink.href = 'data:text/csv;charset=UTF-8,' + encodeURIComponent(csvString);
    //     downloadLink.target = '_blank';
    //     document.body.appendChild(downloadLink);
    //     downloadLink.click();
    //     document.body.removeChild(downloadLink);
    // };

    // export multiple resource details into csv format
    exportData = () => {
        // Define the CSV headers
        const headers = [
            "Accession Series*", "Accession Number*", "Accession Date", "Call Number", "Title*", "Author*",
            "Resource Volume", "Resource Edition", "Resource Language*", "Publisher*", "Number of Pages",
            "Number of Preliminary Pages", "Resource Category*", "Year of Publication", "Department",
            "Resource Type*", "Translator Name", "Translated", "Search Keyword", "Location",
            "ISBN Number", "Resource Condition", "Invoice/Bill No.", "Invoice/Bill Date",
            "Price", "Discount (in %)", "Net Price (in ₹ Per Copy)", "Resource Status"
        ];

        const fileName = 'Resource Details.xlsx';
        const rowData = [];

        // Function to extract values from string (handles the '>>' split)
        function extractValue(str) {
            if (str.includes('>>')) {
                let value = str.split('>>')[1];
                return value.trim(); // Trim spaces around the value after '>>'
            }
            return str.trim(); // Return the original string if '>>' is not found
        }

        // Loop through the resource data and generate rows for the table
        Object.keys(this.state.resourceMultipleDetailsData).forEach(key => {
            const resource = this.state.resourceMultipleDetailsData[key];

            let locationValue = resource.location_name !== "Not present" ? extractValue(resource.location_name) : "";
            let categoryNameValue = resource.resource_category_name ? extractValue(resource.resource_category_name) : "";
            let invoiceNoValue = resource.billno !== "Not present" ? resource.billno : "";
            let departmentNameValue = resource.stream_name !== "Not present" ? resource.stream_name : "";

            const row = [
                resource.AccessionText || '', // Accession Series
                resource.accessionnumber || '', // Accession Number
                resource.accession_date || '', // Accession Date
                resource.callNumber || '', // Call Number
                resource.title || '', // Title
                resource.author || '', // Author
                resource.volume || '', // Resource Volume
                resource.edition || '', // Resource Edition
                resource.resource_lang || '', // Resource Language
                resource.publishername || '', // Publisher
                resource.number_of_pages || '', // Number of Pages
                resource.preliminary_pages || '', // Number of Preliminary Pages
                categoryNameValue || '', // Resource Category
                resource.yearOfPublication || '', // Year of Publication
                departmentNameValue || '', // Department
                resource.resource_type || '', // Resource Type
                resource.translator || '', // Translator Name
                resource.transalated || '', // Translated
                resource.search_key_word || '', // Search Keyword
                locationValue || '', // Location
                resource.isbn_number || '', // ISBN Number
                resource.resource_condition || '', // Resource Condition
                invoiceNoValue || '', // Invoice/Bill No.
                resource.bill_date || '', // Invoice/Bill Date
                resource.price || '', // Price
                resource.discount || '', // Discount
                resource.netprice || '', // Net Price
                resource.resource_status || '' // Resource Status
            ];

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);

    };

    // download re-requisite data in excel format
    exportPreRequisiteData = () => {
        // Define the CSV headers
        const headers = this.state.preRequisiteCSVHeadersForResources.map(header => header.label);

        const fileName = 'PreRequisite_Resource_Details.xlsx';
        const rowData = [];

        // Loop through the resource data and generate rows for the table
        this.state.preRequisiteData.forEach(resource => {
            const row = this.state.preRequisiteCSVHeadersForResources.map(header => {
                // Access each key dynamically from resource using the header key
                return resource[header.key] || ''; // If no value exists, return an empty string
            });

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);
    };

    // CHOOSE UPDATE RESOURCE COMPONENT
    chooseFileComponent = () => {
        return (
            <>
                <div className="import-info">
                    <div className="import-info-title ">
                        <p className="import-h5">Steps to Import Resource:</p>
                    </div>
                    <ol className="instruction-list mt-2 mb-2">
                        <li>Resource can be imported in excel format..</li>
                        <li>Excel should be in specified format for import to work correctly.</li>
                        <li>
                            Refer the below example while adding content to the excel.  &nbsp;
                            <span className="download-links font-weight-bold" onClick={() => this.exportData()}>
                                Download Resource Details Excel File
                                &nbsp;<FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {this.props.csvLoading &&
                                <span> &nbsp;<FontAwesomeIcon icon={['fas', 'circle-notch']} size={'md'} className='rotate' style={{ color: '#0465AC' }} /></span>
                            }
                        </li>
                        <li>Refer the prerequire data to import.
                            &nbsp;
                            {/* <CSVLink
                                onFileLoaded={this.state.preRequisiteData}
                                data={this.state.preRequisiteData}
                                id='downloadPreRequisitePostEventDetails'
                                headers={this.state.preRequisiteHeaders}
                                filename={this.state.preRequisiteFileName}
                            > */}
                            <span
                                className={`download-links font-weight-bold ${(!this.state.loadingPurchaseOrderData) ? 'download-links' : 'disabledLink'}`}
                                onClick={() => this.exportPreRequisiteData()}
                            >
                                Download Prerequisite Excel File <FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {/* </CSVLink> */}
                        </li>
                    </ol>

                    <div className="import-info-preview">
                        {
                            this.state.csvData.length > 0 ? (
                                <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                    <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                        <thead>
                                            {
                                                this.state.updateResourceHeadersArray.map((item) => {
                                                    return (
                                                        <th>{item}</th>
                                                    )
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.updateResourceDetailsArray.map((item, index) => {
                                                    if (item != undefined) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    this.state.updateResourceHeadersArray.map((keys) => {
                                                                        if (typeof item[keys] == 'object') {
                                                                            return <td>{item[keys]['value']}</td>
                                                                        } else {
                                                                            return <td>{item[keys]}</td>
                                                                        }
                                                                    })
                                                                }

                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) :
                                <>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                        <span style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon></span>
                                        <p className="mx-2">You can view the preview of chosen file here.</p>
                                    </div>
                                </>
                        }

                    </div>

                </div>
                <div className="import-info-note mt-2 mb-3">
                    <p>Once you download the sample Excel file. Update the neccessary content. In order to import the updated file you have to upload by clicking on the button mentioned below.</p>
                </div>
                <div className="import-body">
                    <div className="d-flex align-items-center flex-wrap">
                        <div style={{ display: "none" }}>
                            <form ref={this.myRef}>
                                <input
                                    type="file"
                                    id="react-excel-reader-input"
                                    accept=".xlsx, .xls"
                                    onChange={this.handleExcelInput}
                                    style={{ display: 'none' }}
                                />
                            </form>
                            {/* <CSVReader
                                cssClass="csv-reader-input"
                                label="Select CSV file"
                                onFileLoaded={this.handleCSVInput}
                                parserOptions={papaparseOptions}
                            /> */}
                        </div>
                        <button type="button" className="btn import-btn" onClick={this.openFileInput}>
                            <FontAwesomeIcon icon={['fas', 'paperclip']} size={'lg'} color={"#FFF"}></FontAwesomeIcon> Choose File
                        </button>
                        {
                            Object.keys(this.state.selectedCSVFiles).length > 0 ?
                                <span>
                                    <span>
                                        {this.state.selectedCSVFiles['name']}
                                        <span style={{ "cursor": 'pointer' }} onClick={() => {
                                            this.removeCSVFile()
                                            this.myRef.current.reset()
                                        }}>
                                            <FontAwesomeIcon icon={['fas', 'times']} size={'md'}></FontAwesomeIcon>
                                        </span>
                                    </span>
                                </span>
                                : <p className="mb-0"><span className="text-danger">*</span>Please choose your excel file to import.</p>
                        }
                    </div>
                </div>
                {
                    this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                    <div className="alert alert-danger" style={{ maxHeight: '20vh', overflow: "auto" }}>
                        {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                                return <p className="text-danger my-2">Header {item.cell}-{item.message}</p>
                            })
                        }
                    </div>
                }
            </>
        )
    }

    // IMPORT CSV FILE COMPONENT 
    importCSVFileComponent = () => {
        return (
            <>
                <div className="previw-sheet" style={{ minHeight: '40vh' }}>
                    {
                        this.state.csvData.length > 0 ? (
                            <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                    <thead>
                                        <th className="td-dense">{"Sr. No."}</th>
                                        <th className="td-dense">{"Status"}</th>
                                        {/* {this.state.currentProgress == 0 ? "Error Location" : } */}
                                        {
                                            this.state.updateResourceHeadersArray.map((item) => {
                                                return (
                                                    <th className="td-dense">
                                                        {item === 'Title' ? (
                                                            <>
                                                                {item} <span className="text-danger">*</span>
                                                            </>
                                                        ) : (
                                                            item
                                                        )}
                                                    </th>
                                                )
                                            })
                                        }
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.updateResourceDetailsArray.map((item, index) => {

                                                if (item != undefined) {
                                                    return (

                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td className="td-dense">
                                                                {
                                                                    this.getCurrentStatusComponent(index, item['verificationStatus'], item['importStatus'])
                                                                }
                                                            </td>

                                                            {
                                                                this.state.updateResourceHeadersArray.map((keys, cellIndex) => {

                                                                    // Multi select : Conditional logic based on 'keys'
                                                                    if (keys === "Publisher*") {
                                                                        multipleSelectOption = Object.values(this.props.publisherData).map(item => ({
                                                                            value: item.name,
                                                                            label: item.name,
                                                                        }));
                                                                    }
                                                                    else if (keys === "Resource Category*") {
                                                                        multipleSelectOption = Object.values(this.props.resourceCategoryData).flatMap(item => {
                                                                            // Start with the category itself
                                                                            const categoryOption = {
                                                                                value: item.name,
                                                                                label: item.name,
                                                                                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                                                            };

                                                                            // If the category has subcategories, add those as well
                                                                            const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                                                value: subCategory.subCategoryName,
                                                                                label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                                                isDisabled: false, // Subcategory is always enabled
                                                                            }));

                                                                            // Return the category option followed by the subcategory options
                                                                            return [categoryOption, ...subCategoryOptions];
                                                                        });
                                                                    }
                                                                    else if (keys === "Department") {
                                                                        multipleSelectOption = Object.values(this.props.streamListData).map(item => ({
                                                                            value: item.name,
                                                                            label: item.name,
                                                                        }));
                                                                    }

                                                                    // Check if item[keys] is a string before using split
                                                                    let itemValues = [];
                                                                    if (typeof item[keys] === 'string') {
                                                                        // If it's a string, split it by commas
                                                                        itemValues = item[keys].split(',').map(val => val.trim());
                                                                    } else if (Array.isArray(item[keys])) {
                                                                        // If it's already an array, just use it
                                                                        itemValues = item[keys];
                                                                    }
                                                                    // else {
                                                                    //     // Handle other types (e.g., if it's an object or undefined, handle it as needed)
                                                                    //     toast.warn('Unexpected type for item[keys]:', typeof item[keys], {
                                                                    //         position: "top-right",
                                                                    //         autoClose: 2000,
                                                                    //         hideProgressBar: false,
                                                                    //         closeOnClick: true,
                                                                    //         pauseOnHover: true,
                                                                    //         draggable: true,
                                                                    //         progress: undefined,
                                                                    //     });
                                                                    // }

                                                                    // Create options array based on itemValues
                                                                    const options = itemValues.map(value => ({
                                                                        value: value,
                                                                        label: value, // or any other custom label format
                                                                    }));

                                                                    // Set the selected value for react-select
                                                                    const selectedOption = options.filter(option => itemValues.includes(option.value));

                                                                    // Determine if the row is disabled based on the status
                                                                    const isRowDisabled = item['importStatus'] === 'success';
                                                                    const isInputFieldDisable = item['importStatus'] === 'success' || keys === 'Invoice/Bill Date';
                                                                    return (
                                                                        <td className={this.state.currentErrorObject['row'] == index ? "td-dense-highlight" : "td-dense"}>
                                                                            <div className={this.state.currentErrorObject['row'] == index ? "table-row-highlighter" : ""}>
                                                                                {
                                                                                    keys == "Accession Series*" || keys == "Resource Language*" || keys == "Resource Type*" || keys == "Location" || keys == "Resource Condition" || keys == "Invoice/Bill No." || keys == "Resource Status" ?
                                                                                        <>
                                                                                            <select
                                                                                                id="series-selction"
                                                                                                value={item[keys]} // Set the selected value
                                                                                                className="form-control"
                                                                                                onChange={(e) => {
                                                                                                    this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                                }}
                                                                                                disabled={isRowDisabled}
                                                                                                style={{
                                                                                                    width: "max-content"
                                                                                                }}
                                                                                            >
                                                                                                {/* <option value="">{item[keys] ? item[keys] : keys}</option> */}

                                                                                                {/* When keys are "Accession Series*" */}
                                                                                                {keys === "Accession Series*" &&
                                                                                                    Object.values(this.props.accessionSeriesListData).map((data) => {
                                                                                                        const label = data.label.length > 20 ? data.label.slice(0, 20) + '...' : data.label;
                                                                                                        return (
                                                                                                            <option key={data.value} value={data.label} title={data.label}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Resource Language*" */}
                                                                                                {keys === "Resource Language*" &&
                                                                                                    resourceLanguageData.map((data, index) => {
                                                                                                        const label = data.length > 20 ? data.slice(0, 20) + '...' : data;
                                                                                                        return (
                                                                                                            <option key={index} value={data}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Resource Type*" */}
                                                                                                {keys === "Resource Type*" &&
                                                                                                    resourceTypeData.map((data, index) => {
                                                                                                        const label = data.length > 20 ? data.slice(0, 20) + '...' : data;
                                                                                                        return (
                                                                                                            <option key={index} value={data} title={data}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Location" */}
                                                                                                {keys === "Location" &&
                                                                                                    Object.values(this.props.locationListData)?.map((data) => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                {/* Disable the parent location if it has sublocations */}
                                                                                                                <option
                                                                                                                    key={data.value}
                                                                                                                    value={data.name}
                                                                                                                    disabled={data.sublocations && data.sublocations.length > 0}
                                                                                                                    title={data.name}
                                                                                                                >
                                                                                                                    {data.name.length > 25 ? data.name.slice(0, 25) + '...' : data.name}
                                                                                                                </option>

                                                                                                                {data.sublocations && data.sublocations.length > 0 &&
                                                                                                                    data.sublocations.map((sublocation) => {
                                                                                                                        const subLocationLabel = `${data.name} => ${sublocation.sublocationName}`;
                                                                                                                        return (
                                                                                                                            <option
                                                                                                                                key={sublocation.sublocationId}
                                                                                                                                value={sublocation.sublocationName}
                                                                                                                                title={subLocationLabel} // Full name for tooltip on hover
                                                                                                                            >
                                                                                                                                {/* {data.name} ={'>'} {sublocation.sublocationName} */}
                                                                                                                                {subLocationLabel.length > 20 ? subLocationLabel.slice(0, 20) + '...' : subLocationLabel}
                                                                                                                            </option>
                                                                                                                        );
                                                                                                                    })
                                                                                                                }
                                                                                                            </>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Resource Condition" */}
                                                                                                {keys === "Resource Condition" &&
                                                                                                    resourceConditionData.map((data, index) => {
                                                                                                        const label = data.length > 20 ? data.slice(0, 20) + '...' : data;
                                                                                                        return (
                                                                                                            <option key={index} value={data} title={data}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Invoice/Bill No." */}
                                                                                                {keys === "Invoice/Bill No." &&
                                                                                                    Object.values(this.props.invoiceData).map((data) => {
                                                                                                        const label = data.billno.length > 20 ? data.billno.slice(0, 20) + '...' : data.billno;
                                                                                                        return (
                                                                                                            <option key={data.value} value={data.billno} title={data.billno}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Resource Status" */}
                                                                                                {keys === "Resource Status" &&
                                                                                                    Object.values(this.props.resourceStatusData).map((data) => {
                                                                                                        const label = data.status.length > 20 ? data.status.slice(0, 20) + '...' : data.status;
                                                                                                        return (
                                                                                                            <option key={data.unique_id} value={data.status} title={data.status}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }
                                                                                            </select>

                                                                                            {/* <span class="text-danger">{item['purchaseOrderNameId'] ? null : "Invalid purchase order name"}</span> */}
                                                                                        </>
                                                                                        :
                                                                                        keys == "Publisher*" || keys == "Resource Category*" || keys == "Department" ?
                                                                                            <>
                                                                                                <Select
                                                                                                    isMulti
                                                                                                    options={multipleSelectOption}
                                                                                                    value={selectedOption}
                                                                                                    onChange={(e) => {
                                                                                                        this.getValueOfMultipleSelect(index, keys, e);
                                                                                                    }}
                                                                                                    // isSearchable
                                                                                                    onInputChange={(inputValue) => {
                                                                                                    }}
                                                                                                    onKeyDown={(event) => {
                                                                                                    }}
                                                                                                    className='basic-multi-select'
                                                                                                    // Apply custom styles to the dropdown
                                                                                                    styles={{
                                                                                                        menu: (base) => ({
                                                                                                            ...base,
                                                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                                                        }),
                                                                                                        menuPortal: (base) => ({
                                                                                                            ...base,
                                                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                                                        }),
                                                                                                        multiValue: (base) => ({
                                                                                                            ...base,
                                                                                                            display: 'flex',
                                                                                                            flexDirection: 'column', // Make selected options stack vertically
                                                                                                            marginBottom: '5px', // Adjust space between selected options
                                                                                                        }),
                                                                                                        multiValueLabel: (base, state) => ({
                                                                                                            ...base,
                                                                                                            padding: '5px 10px', // Add padding to the labels for better readability
                                                                                                            whiteSpace: 'normal', // Allow text wrapping if needed
                                                                                                            cursor: 'pointer', // Add pointer cursor to indicate it's hoverable
                                                                                                            maxWidth: '200px', // Limit the width to prevent text overflow
                                                                                                            overflow: 'hidden', // Hide overflow text
                                                                                                            textOverflow: 'ellipsis', // Add ellipsis for long names
                                                                                                            title: state.data.label, // Show full name as a tooltip
                                                                                                        }),
                                                                                                        multiValueRemove: (base) => ({
                                                                                                            ...base,
                                                                                                            display: 'none', // Optionally hide the remove button if you don't need it
                                                                                                        }),
                                                                                                        option: (base, state) => ({
                                                                                                            ...base,
                                                                                                            fontSize: '12px',
                                                                                                            fontWeight: '400',
                                                                                                            backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                                                                            color: state.isDisabled ? '#999' : '#555',
                                                                                                            cursor: state.isDisabled ? 'not-allowed' : 'default',
                                                                                                        }),
                                                                                                    }}
                                                                                                    // Specify that the menu should be rendered in the document body
                                                                                                    menuPortalTarget={document.body}
                                                                                                    isDisabled={isRowDisabled}
                                                                                                />
                                                                                            </>
                                                                                            :
                                                                                            <input
                                                                                                type='text'
                                                                                                placeholder={`Enter ${keys}`}
                                                                                                value={item[keys]}
                                                                                                ref={(el) => this.tableObject[`${index}-${cellIndex}`] = el}
                                                                                                style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                                                                className="form-control filterInput"
                                                                                                onChange={(e) => {
                                                                                                    this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                                }}
                                                                                                disabled={isInputFieldDisable}
                                                                                            />
                                                                                }

                                                                            </div>
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                }
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        ) : <p>Data is not available.</p>
                    }
                </div>
                <p><span className="text-danger my-2 font-size14">*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them. </p>

                <div className="inspect-console">
                    <div className="table-responsive">
                        <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        <div className="import-progress">
                                            {
                                                this.state.importProgress.map((item, index) => {
                                                    return (
                                                        <div className="tab-wrapper">
                                                            <div className="step-wrapper">
                                                                <span className={this.state.currentProgress == index ? "circle-tab" : "circle-tab-muted"} style={this.checkImportTabProgress(index) ? { background: "green", color: "#FFF" } : {}}>{index + 1}</span>
                                                                {index < this.state.importProgress.length - 1 && <span className={this.state.validations['isVerified'] ? "step-line bg-success" : "step-line "}></span>}
                                                            </div>
                                                            <p className={this.state.currentProgress == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p>
                                                        </div>

                                                    )
                                                })
                                            }
                                        </div>
                                    </th>

                                    <th>
                                        <div className="d-flex justify-content-between align-items-center" >
                                            <span onClick={() => {
                                                this.state.currentPointer > 0 && this.navigateToPreviousError()
                                            }} disabled={true} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-left']} size="md"></FontAwesomeIcon></span>
                                            <p className="mb-0 font-weight-bold">Error Location :
                                                {Object.keys(this.state.currentErrorObject).length > 0 &&
                                                    `Rows : ${this.state.currentErrorObject['row'] + 1} Columns : ${this.state.currentErrorObject['key']}`
                                                }
                                            </p>
                                            <span onClick={() => {
                                                this.state.currentPointer < this.state.errorLogs.length && this.navigateToNextError()
                                            }} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-right']} size="md"></FontAwesomeIcon></span>
                                        </div>
                                    </th>
                                </tr>
                                <tr>

                                    <th align="center" style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        {
                                            this.state.errorLogs.length > 0 ?
                                                (
                                                    <div>{this.ErrorViewConsole()}</div>
                                                )
                                                : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2 mb-0">After verification, You can view content which has errors.</p></span>
                                        }
                                        {/* 
										{
											this.state.errorMessageObjArray?.length > 0 ?
												this.state.errorMessageObjArray?.map((row) => {
													let rowIndex = row['rowIndex'];
													let message = row['message'];
													return <div>Row : {rowIndex} | Error : {message}</div>;
												})
												:
												<span className="initial-preview">
													<FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999" />
													<p className="mx-2 mb-0">After verification, You can view content which has errors.</p>
												</span>
										} */}

                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </>
        )
    }

    // 	GET CURRENT STATUS COMPONENT
    getCurrentStatusComponent = (index, verificationStatus = "pending", importStatus = "pending") => {
        {
            return this.state.importPointer['rowindex'] == index ?
                <div>
                    {
                        this.state.importPointer['loading'] ?
                            <div class="spinner-border spinner-border-sm" role="status" >
                                <span class="sr-only">{this.state.importPointer['status']}...</span>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>{this.state.importPointer['status']}</div>
                                {/* {
                                    this.state.importPointer['status'] == 'failed' &&
                                    // importStatus == 'failed' &&
                                    <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                                        this.setState({
                                            loadingImportProcess: true
                                        }, () => {
                                            this.apiCallToImportVerifyResourceDetails(index, this.state.importProgressSummary, 'true')
                                        })
                                    }>
                                        Retry
                                    </button>
                                } */}
                            </div>

                    }

                </div>

                : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div>{importStatus}</div>

                    {/* {
                        // this.state.importPointer['status'] == 'failed' &&
                        importStatus == 'failed' &&
                        <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                            this.setState({
                                loadingImportProcess: true
                            }, () => {
                                this.apiCallToImportVerifyResourceDetails(index, this.state.importProgressSummary, 'true')
                            })
                        }>
                            Retry
                        </button>
                    } */}
                </div>
        }
    }

    //function to download prerequisite data 
    downloadPrerequisitedataCSV = () => {
        let preRequisiteData = this.state.preRequisiteCSVDataForResources
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty


        // For purchaseOrderNameList
        if (Object.values(this.state.poData).length > 0) {
            Object.keys(this.state.poData).map((Id, index) => {
                let poName = this.state.poData[Id]
                // Concatenating seriesTitle and seriesCounter
                let concatenatedPoName = poName.seriesTitle + poName.seriesCounter;

                if (poName != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].poName = concatenatedPoName
                    } else {
                        preRequisiteData.push({ poName: concatenatedPoName })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }
    // Strip HTML
    stripHtml(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    // //FUNCTION DEFINED TO GET THE INPUT OF THE IMPORTED CSV
    // handleCSVInput = (csvData, fileInformation) => {
    //     let poSeriesId = '';
    //     this.setState({
    //         selectedCSVFiles: fileInformation
    //     })

    //     if (fileInformation.type !== "text/csv") {
    //         this.setState({
    //             selectedCSVFiles: {},
    //             successModal: true,
    //             successModalType: "error",
    //             successMessage: "Please select csv file.",
    //             isValidAttachment: false
    //         })
    //     } else {
    //         let updateResourceDetailsArray = [];
    //         let updateResourceHeadersArray = [];

    //         if (csvData.length > 0) {
    //             csvData = csvData.filter((rowArray, index) => rowArray.length > 1 && !rowArray.every((val) => val == ""));

    //             // Read CSV Headers
    //             let headers = csvData[0];

    //             if (headers != undefined && headers.length > 0) {
    //                 headers.map((headerName, index) => {
    //                     if (headerName != undefined && headerName.trim() !== "") {
    //                         updateResourceHeadersArray.push(headerName.trim());
    //                     }
    //                 })
    //             } else {
    //                 toast.warn("Invalid headers found in imported csv file.", {
    //                     position: "top-right",
    //                     autoClose: 2000,
    //                     hideProgressBar: false,
    //                     closeOnClick: true,
    //                     pauseOnHover: true,
    //                     draggable: true,
    //                     progress: undefined,
    //                 });
    //             }

    //             // Read CSV Actual Body Data
    //             if (updateResourceHeadersArray.length > 0) {
    //                 csvData.map((csvRow, index) => {
    //                     if (index != 0) {
    //                         let resourceObject = {};

    //                         for (let i = 0; i < updateResourceHeadersArray.length; i++) {
    //                             if (csvRow[i] == undefined || csvRow[i] == null || csvRow[i] == "") {
    //                                 resourceObject[updateResourceHeadersArray[i]] = "";
    //                             } else {
    //                                 resourceObject[updateResourceHeadersArray[i]] = csvRow[i];
    //                             }
    //                         }

    //                         poSeriesId = resourceObject['Purchase Order Name'] ?
    //                             (Object.values(this.state.poData).find(po => (po.seriesTitle + po.seriesCounter) === resourceObject['Purchase Order Name'])?.Uniqueid || '')
    //                             : '';

    //                         resourceObject['purchaseOrderNameId'] = poSeriesId;

    //                         updateResourceDetailsArray.push({ ...resourceObject, verificationStatus: "pending", importStatus: "pending", loading: false });
    //                     }
    //                 })
    //             }
    //         }

    //         this.setState({
    //             csvData: [...csvData],
    //             updateResourceDetailsArray: updateResourceDetailsArray,
    //             updateResourceHeadersArray: updateResourceHeadersArray
    //         }, () => {
    //             this.validateCSVFileHeaders();

    //         })
    //     }
    // }

    handleExcelInput = (event) => {
        const file = event.target.files[0];

        const fileDetails = {
            name: file.name,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
            webkitRelativePath: file.webkitRelativePath,
            size: file.size,
            type: file.type
        };


        this.setState({
            selectedCSVFiles: fileDetails
        })

        if (!file) {
            this.setState({
                successModalType: "error",
                successMessage: "No file selected.",
                isValidAttachment: false,
                successModal: true,
            });
            return;
        }

        if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            file.type !== "application/vnd.ms-excel") {
            this.setState({
                selectedCSVFiles: {},
                successModalType: "error",
                successMessage: "Please select a valid Excel file.",
                isValidAttachment: false,
                successModal: true,
            })
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryData = e.target.result;
            const workbook = XLSX.read(binaryData, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

            this.processExcelData(sheetData);
        };

        reader.readAsBinaryString(file);
    }

    processExcelData = (sheetData) => {
        if (sheetData.length === 0) {
            this.setState({
                successModalType: "error",
                successMessage: "Excel file is empty.",
                isValidAttachment: false,
            });
            return;
        }

        const headers = sheetData[0];
        const rows = sheetData.slice(0);

        let updateResourceDetailsArray = [];
        let updateResourceHeadersArray = [];
        // let validations = this.state.validations;
        // let headersArrayObject = this.state.preRequisiteCSVHeadersForStudentMarks;

        // // Validate headers
        if (headers != undefined && headers.length > 0) {
            headers.map((headerName, index) => {
                if (headerName != undefined && headerName.trim() !== "") {
                    updateResourceHeadersArray.push(headerName.trim());
                }
            })
        } else {
            toast.warn("Invalid headers found in imported excel file.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

        // Find the index of the column
        const accessionDateIndex = updateResourceHeadersArray.indexOf("Accession Date");
        const invoiceDateIndex = updateResourceHeadersArray.indexOf("Invoice/Bill Date");
        const invoiceBillNoIndex = updateResourceHeadersArray.indexOf("Invoice/Bill No.");

        // // Read Excel Actual Body Data
        // if (updateResourceHeadersArray.length > 0) {
        //     rows.map((csvRow, index) => {
        //         if (index != 0) {
        //             let resourceObject = {};

        //             for (let i = 0; i < updateResourceHeadersArray.length; i++) {
        //                 if (csvRow[i] == undefined || csvRow[i] == null || csvRow[i] == "") {
        //                     resourceObject[updateResourceHeadersArray[i]] = "";
        //                 } else {
        //                     resourceObject[updateResourceHeadersArray[i]] = csvRow[i];
        //                 }
        //             }

        //             updateResourceDetailsArray.push({ ...resourceObject, verificationStatus: "pending", importStatus: "pending", loading: false });
        //         }
        //     })
        // }

        // Read Excel Actual Body Data including date
        if (updateResourceHeadersArray.length > 0) {
            rows.map((csvRow, index) => {
                if (index !== 0) {
                    let resourceObject = {};
                    let invoiceDetails = {}; // Declare invoiceDetails outside the loop

                    for (let i = 0; i < updateResourceHeadersArray.length; i++) {
                        let value = csvRow[i];

                        // Format the "Accession Date" if it exists and is a valid date
                        if (i === accessionDateIndex && value) {
                            let formattedDate = this.formatDate(value);  // Format the date
                            value = formattedDate;  // Assign the formatted date
                        }

                        // If the current column is invoiceBillNo and there's a value
                        if (i === invoiceBillNoIndex && value) {
                            // Assuming invoiceData is an array of objects where each object has "billno" and "billDate"
                            invoiceDetails = this.props.invoiceData.find(item => item.billno === value);
                        }

                        // Check if the current column is invoiceDate
                        if (i === invoiceDateIndex && value) {
                            let formattedInvoiceDate = this.formatDate(value);
                            // If we found matching invoiceDetails and the entered date does not match the billDate
                            if (invoiceDetails && formattedInvoiceDate !== invoiceDetails.billdate) {
                                // Update the invoice date to match the billDate from invoiceDetails
                                value = invoiceDetails.billdate;  // Set the date from invoiceDetails
                            } else {
                                // If the entered date is valid, format it
                                let formattedDate = formattedInvoiceDate;  // Format the date
                                value = formattedDate;  // Assign the formatted date
                            }
                        }

                        // Add the value to the resource object
                        resourceObject[updateResourceHeadersArray[i]] = value === undefined || value === null ? "" : value;
                    }

                    // Add the updated resource object to the final array
                    updateResourceDetailsArray.push({
                        ...resourceObject,
                        verificationStatus: "pending",
                        importStatus: "pending",
                        loading: false
                    });
                }
            });
        }

        this.setState({
            csvData: [...rows],
            updateResourceDetailsArray: updateResourceDetailsArray,
            updateResourceHeadersArray: updateResourceHeadersArray
        }, () => {
            this.validateCSVFileHeaders();

        })
    };

    formatDate = (dateValue) => {
        // If the value is a number (Excel timestamp), convert it to a JavaScript date
        if (typeof dateValue === 'number') {
            const excelStartDate = new Date(Date.UTC(1900, 0, 1));  // Use UTC to avoid timezone effects
            excelStartDate.setUTCDate(excelStartDate.getUTCDate() + dateValue - 2); // Adjust for the 1900 leap year bug
            return this.formatDateString(excelStartDate, "number"); // Format as YYYY-MM-DD
        }

        // If it's a string, try to parse it as a date in multiple formats
        const parsedDate = this.tryParseDate(dateValue);
        if (parsedDate) {
            return this.formatDateString(parsedDate, "string"); // Format as YYYY-MM-DD
        } else {
            return "";  // Return empty if the value is not a valid date
        }
    };

    // Helper function to try parsing the date from multiple formats
    tryParseDate = (dateValue) => {
        // Try parsing a string as an ISO date format (YYYY-MM-DD)
        let parsedDate = new Date(dateValue);
        if (parsedDate instanceof Date && !isNaN(parsedDate)) {
            return parsedDate; // Return parsed date if valid
        }

        // If it doesn't work, try parsing using a format like '10 Nov 2024'
        parsedDate = Date.parse(dateValue);
        if (!isNaN(parsedDate)) {
            return new Date(parsedDate); // Return parsed date if valid
        }

        return null;  // Return null if the date can't be parsed
    };

    // Helper function to format the date object as YYYY-MM-DD
    formatDateString = (date, type) => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        let day = '';
        if (type === "number") {
            day = String(date.getUTCDate()).padStart(2, '0');
        } else {
            day = String(date.getUTCDate() + 1).padStart(2, '0');
        }
        return `${year}-${month}-${day}`;
    };

    // VALIDATE CSV FILE HEADERS
    validateCSVFileHeaders = () => {
        let commonHeaders = [
            "Accession Series*",
            "Accession Number*",
            "Accession Date",
            "Call Number",
            "Title*",
            "Author*",
            "Resource Volume",
            "Resource Edition",
            "Resource Language*",
            "Publisher*",
            "Number of Pages",
            "Number of Preliminary Pages",
            "Resource Category*",
            "Year of Publication",
            "Department",
            "Resource Type*",
            "Translator Name",
            "Translated",
            "Search Keyword",
            "Location",
            "ISBN Number",
            "Resource Condition",
            "Invoice/Bill No.",
            "Invoice/Bill Date",
            "Price",
            "Discount (in %)",
            "Net Price (in ₹ Per Copy)",
            "Resource Status"
        ]
        let mandatoryHeaders = ["Accession Series*", "Accession Number*", "Title*", "Author*", "Resource Language*", "Publisher*", "Resource Category*", "Resource Type*",]
        let updateResourceHeadersArray = this.state.updateResourceHeadersArray;
        let validations = this.state.validations;

        if (updateResourceHeadersArray.length > 0) {
            // Checking Default resource Headers are available or not.
            mandatoryHeaders.map((header, index) => {
                if (!updateResourceHeadersArray.includes(header)) {
                    let validationObject = {
                        touch: true,
                        cell: index + 1,
                        row: 0,
                        status: "error",
                        message: `${header} is mandatory column to import update resource.`,
                        type: "header",
                        errorCount: 0
                    }
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }
            })

            // Checking Dyanamic resource Headers are available or not.
            updateResourceHeadersArray.map((key, index) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    status: "error",
                    message: "",
                    type: "header",
                    errorCount: 0
                }

                let isValidHeader = commonHeaders.some((keys) => {
                    return keys == key.trim();
                })

                let validationMessage = '';
                if (key) {
                    validationMessage = ` ${key} header is invalid.`
                } else {
                    validationMessage = ` ${key} header is missing.`
                }

                if (!isValidHeader) {
                    validationObject.cell = index;
                    validationObject.status = "error";
                    validationObject.message = `Please check default headers. ${validationMessage}`;
                    validationObject.touch = true;
                }


                if (validationObject.touch) {
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }

            })
        }


        if (validations['headersErrors'].length == 0) {
            validations['isHeadersValid'] = true;
        }

        this.setState({
            validations: { ...validations }
        })
    }

    // VALIDATE CSV FILE DATA
    validateCSVFileData = () => {
        let updateResourceDetailsArray = this.state.updateResourceDetailsArray;
        let updateResourceHeadersArray = this.state.updateResourceHeadersArray;
        let validations = { ...this.state.validations, dataErrors: {}, errors: [], isDataValid: false, isVerified: false };
        let verificationSummary = {
            completed: 0,
            failed: 0,
            total: 0,
            pending: 0
        };

        verificationSummary['total'] = updateResourceDetailsArray.length;
        verificationSummary['pending'] = updateResourceDetailsArray.length;
        let verificationPointer = this.state.verificationPointer;

        updateResourceDetailsArray.map((item, rowIndex) => {
            let status = true;
            let hasEarning = true;
            verificationPointer['loading'] = true;
            verificationPointer['status'] = 'verfying';
            verificationPointer['rowindex'] = rowIndex;
            this.setState({
                verificationPointer: verificationPointer
            })

            verificationSummary['pending'] -= verificationSummary['pending'];

            updateResourceHeadersArray.map((key, cellIndex) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "",
                    type: "data",
                    errorCount: 0
                }

                if (validationObject.touch) {
                    status = false;
                    if (validations['dataErrors'][rowIndex] == undefined) {
                        validations['dataErrors'][rowIndex] = {};
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;

                    } else {
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;
                    }
                    item['verificationStatus'] = "failed";
                    validations['isDataValid'] = false;
                }
            })

            if (hasEarning) {
                validations['errors'].push({
                    touch: true,
                    cell: 0,
                    row: rowIndex,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "Please enter atleast one earning component",
                    type: "basic",
                    errorCount: 1
                })

                verificationPointer['status'] = 'failed';
                updateResourceDetailsArray[rowIndex]['verificationStatus'] = 'failed';
                verificationPointer['loading'] = false;
            } else {
                verificationPointer['status'] = status ? 'verified' : 'failed';
                updateResourceDetailsArray[rowIndex]['verificationStatus'] = verificationPointer['status'];
                verificationPointer['loading'] = false;
            }

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];

            this.setState({
                updateResourceDetailsArray: [...updateResourceDetailsArray],
                verificationProgress: verificationSummary,
                verificationPointer: verificationPointer,
            })
        })

        if (validations['errors'].length > 0) {
            let failedCount = 0;
            validations['errors'].map(item => {
                if (!Object.keys(validations['dataErrors']).includes(item.row)) {
                    failedCount++;
                }
            })

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length + failedCount;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];
        }


        if (Object.keys(validations['dataErrors']).length == 0 && validations['errors'].length == 0) {
            validations['isDataValid'] = true;
            validations['isVerified'] = true;
            this.setState({
                currentPointer: 1
            })
        }

        this.setState({
            validations: { ...validations },
            verificationProgress: verificationSummary,
            loadingVerificationProcess: false
        }, () => {
            this.getBugLogs();
        })
    }

    // GET VALUES FORM INPUT FIELDS
    getValueOfRowInputs = (rowIndex, key, value, type) => {
        let updateResourceDetailsArray = this.state.updateResourceDetailsArray;
        let rowObject = updateResourceDetailsArray[rowIndex];
        // if (typeof rowObject[key] == 'object') {
        //     rowObject[key]['value'] = value; // Update nested value if it's an object
        // } else {
        //     rowObject[key] = value; // Update directly if it's a primitive
        // }

        if (key === "Invoice/Bill No." && this.props.invoiceData) {
            // Assuming invoiceData is an array of objects where each object has "billno" and "billDate"
            const selectedInvoice = this.props.invoiceData.find(item => item.billno === value);
            if (selectedInvoice) {
                // Update both "Invoice/Bill No." and "Invoice/Bill Date"
                rowObject["Invoice/Bill No."] = value;
                rowObject["Invoice/Bill Date"] = selectedInvoice.billdate || ''; // Set the corresponding date
            }
        } else {
            // Handle other cases
            if (typeof rowObject[key] == 'object') {
                rowObject[key]['value'] = value; // Update nested value if it's an object
            } else {
                rowObject[key] = value; // Update directly if it's a primitive
            }
        }
        updateResourceDetailsArray[rowIndex] = rowObject;

        this.setState({
            updateResourceDetailsArray: updateResourceDetailsArray
        });
    };

    // GET VALUES FORM Multi-Select FIELDS
    getValueOfMultipleSelect = (rowIndex, key, selectedOptions) => {
        let updateResourceDetailsArray = this.state.updateResourceDetailsArray;
        let rowObject = updateResourceDetailsArray[rowIndex];

        // If the selected options are not empty, update the row object with the selected values
        if (selectedOptions && selectedOptions.length > 0) {
            rowObject[key] = selectedOptions.map(option => option.label); // Set selected values as an array
        } else {
            rowObject[key] = []; // If no options are selected, set it to an empty array
        }

        updateResourceDetailsArray[rowIndex] = rowObject;

        this.setState({
            updateResourceDetailsArray: updateResourceDetailsArray
        });
    }

    // Navigate to previous 
    navigateToPreviousError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer > 0) {
            currentPointer -= 1;
            currentErrorObject = errorLogs[currentPointer];
            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }

    }

    // Navigate to next
    navigateToNextError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer < errorLogs.length - 1) {

            currentPointer += 1;
            currentErrorObject = errorLogs[currentPointer];

            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }
    }

    // CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    // CONSOLE ERROR 
    ErrorViewConsole = () => {
        let { row, message } = this.state.currentErrorObject;
        return (
            <div>
                {
                    this.state.currentErrorObject['key'] != "" && (
                        <div>
                            <p className="mb-0 font-weight-bold text-danger">{this.state.currentErrorObject['message']}</p>
                        </div>
                    )

                }
            </div>
        )
    }

    // API CALL TO IMPORT VERIFY RESOURCE
    apiCallToImportVerifyResourceDetails = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {

        if (rowIndex < this.state.updateResourceDetailsArray.length) {
            let resourceData = this.state.updateResourceDetailsArray[rowIndex];
            let importPointer = this.state.importPointer;
            importPointer['loading'] = true;
            importPointer['status'] = 'importing';
            importPointer['rowindex'] = rowIndex;
            this.setState({
                importPointer: importPointer,
            })

            let errorLogs = this.state.errorLogs;

            let publisherData = [];
            let categoryData = [];
            let departmentData = [];

            // publisher data
            if (typeof resourceData['Publisher*'] === 'string') {
                // If it's a string, split it by commas
                publisherData = resourceData['Publisher*'].split(',').map(val => val.trim());
            } else {
                publisherData = resourceData['Publisher*']
            }

            // category data
            if (typeof resourceData['Resource Category*'] === 'string') {
                // If it's a string, split it by commas
                categoryData = resourceData['Resource Category*'].split(',').map(val => val.trim());
            } else {
                categoryData = resourceData['Resource Category*']
            }

            // department/stream data
            if (typeof resourceData['Department'] === 'string') {
                // If it's a string, split it by commas
                departmentData = resourceData['Department'].split(',').map(val => val.trim());
            } else {
                departmentData = resourceData['Department']
            }

            let accessionSeriesName = resourceData['Accession Series*'] ? Base64.encode(resourceData['Accession Series*']) : "";
            let accessionNumber = resourceData['Accession Number*'] ? Base64.encode(resourceData['Accession Number*']) : "";
            // let FormattedAccessionDate = resourceData['Accession Date']
            //     ? new Date(resourceData['Accession Date']).toISOString().split('T')[0] // Convert to ISO format and take the date part
            //     : "";
            let FormattedAccessionDate = resourceData['Accession Date'] ? resourceData['Accession Date'] : "";
            let accessionDate = FormattedAccessionDate ? Base64.encode(FormattedAccessionDate) : "";
            let callNumber = resourceData['Call Number'] ? Base64.encode(resourceData['Call Number']) : "";
            let titleName = resourceData['Title*'] ? Base64.encode(resourceData['Title*']) : "";
            let authorName = resourceData['Author*'] ? Base64.encode(resourceData['Author*']) : "";
            let volumeName = resourceData['Resource Volume'] ? Base64.encode(resourceData['Resource Volume']) : "";
            let editionName = resourceData['Resource Edition'] ? Base64.encode(resourceData['Resource Edition']) : "";
            let resourceLanguageName = resourceData['Resource Language*'] ? Base64.encode(resourceData['Resource Language*']) : "";
            let publisherName = resourceData['Publisher*'] ? Base64.encode(publisherData) : "";
            let NoOfPages = resourceData['Number of Pages'] ? Base64.encode(resourceData['Number of Pages']) : "";
            let preliminaryPages = resourceData['Number of Preliminary Pages'] ? Base64.encode(resourceData['Number of Preliminary Pages']) : "";
            let categoryName = resourceData['Resource Category*'] ? Base64.encode(categoryData) : "";
            let yearOfPublication = resourceData['Year of Publication'] ? Base64.encode(resourceData['Year of Publication']) : "";
            let streamIdName = resourceData['Department'] ? Base64.encode(departmentData) : "";
            let resourceTypeName = resourceData['Resource Type*'] ? Base64.encode(resourceData['Resource Type*']) : "";
            let translatorName = resourceData['Translator Name'] ? Base64.encode(resourceData['Translator Name']) : "";
            let isTranslated = resourceData['Translated'] ? Base64.encode(resourceData['Translated']) : Base64.encode("Yes");
            let keywordName = resourceData['Search Keyword'] ? Base64.encode(resourceData['Search Keyword']) : "";
            let locationName = resourceData['Location'] ? Base64.encode(resourceData['Location']) : "";
            let isbnNumber = resourceData['ISBN Number'] ? Base64.encode(resourceData['ISBN Number']) : "";
            let resourceConditionName = resourceData['Resource Condition'] ? Base64.encode(resourceData['Resource Condition']) : Base64.encode("Good");
            let invoiceNumber = resourceData['Invoice/Bill No.'] ? Base64.encode(resourceData['Invoice/Bill No.']) : "";
            let priceData = resourceData['Price'] ? Base64.encode(resourceData['Price']) : "";
            let discountData = resourceData['Discount (in %)'] ? Base64.encode(resourceData['Discount (in %)']) : "";
            let resourceStatus = resourceData['Resource Status'] ? Base64.encode(resourceData['Resource Status']) : "";

            let requestData = {
                "iid": this.props.resourceSearchIID, // config.institute_id,
                "facultyId": config.faculty_id,
                "accessionseriesid": accessionSeriesName,
                "accessionnumber": accessionNumber,
                "accession_date": accessionDate,
                "callNumber": callNumber,
                "title": titleName,
                "author": authorName,
                "volume": volumeName,
                "edition": editionName,
                "resource_lang": resourceLanguageName,
                "publisherName": publisherName,
                "number_of_pages": NoOfPages,
                "preliminarypages": preliminaryPages,
                "resourceCategoryName": categoryName,
                "yearOfPublication": yearOfPublication,
                "stream_id": streamIdName,
                "resource_type": resourceTypeName,
                "translatorName": translatorName,
                "Translated": isTranslated,
                "keyword": keywordName,
                "location": locationName,
                "isbn_number": isbnNumber,
                "resource_condition": resourceConditionName,
                "invoiceno": invoiceNumber,
                "price": priceData,
                "discount": discountData,
                "resource_status": resourceStatus,
                "iidArray": this.props.iidArray.iidArray
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'LibraryVerifyMultipleResourceDetails',
                requestData,
                "/api/library/instructor.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToImportVerifyResourceDetails(rowIndex, importProgressSummary, isRetry);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    // set response
                    // this.setState(prevState => ({
                    //     verifyImportResourceResult: [...prevState.verifyImportResourceResult, apiResult]
                    // }));
                    this.setState({
                        verifyImportResourceResult: apiResult
                    })
                    if (apiResult.status == 'success') {
                        let updateResourceDetailsArray = this.state.updateResourceDetailsArray;
                        let rowItem = updateResourceDetailsArray[rowIndex];

                        rowItem['status'] = 'completed'
                        updateResourceDetailsArray[rowIndex] = rowItem;

                        importProgressSummary['completed'] += 1;
                        if (isRetry != "true") {

                            importProgressSummary['pending'] -= 1;
                        } else {
                            importProgressSummary['failed'] -= 1;
                        }

                        importPointer['status'] = 'success';
                        updateResourceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;


                        let findIndex = errorLogs.findIndex(obj => obj.row == rowIndex)

                        if (findIndex != -1) {
                            errorLogs.splice(findIndex, 1);
                        }


                        this.setState({
                            updateResourceDetailsArray: updateResourceDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentPointer: 0,
                            currentErrorObject: errorLogs.length > 0 ? errorLogs[0] : {}
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyResourceDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                    else {
                        // let rowIndex = rowIndex + 1;
                        let errorObj = {};
                        errorObj['row'] = rowIndex;
                        errorObj['key'] = apiResult.key;
                        errorObj['message'] = apiResult.message;

                        // errorLogs.push(errorObj);

                        let foundIndex = errorLogs.findIndex(obj => obj.row == rowIndex);
                        if (foundIndex != -1) {
                            errorLogs[foundIndex] = errorObj;
                        }
                        else {
                            errorLogs.push(errorObj);
                        }

                        // currentErrorObject['rowIndex'] = rowIndex + 1;
                        // currentErrorObject['key'] = apiResult.key;
                        // currentErrorObject['message'] = apiResult.message;
                        let updateResourceDetailsArray = this.state.updateResourceDetailsArray;
                        let rowItem = updateResourceDetailsArray[rowIndex];
                        rowItem['status'] = 'failed';
                        updateResourceDetailsArray[rowIndex] = rowItem;
                        if (isRetry != "true") {
                            importProgressSummary['failed'] += 1;
                            importProgressSummary['pending'] -= 1;
                        }

                        importPointer['status'] = 'failed';

                        updateResourceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;

                        this.setState({
                            updateResourceDetailsArray: updateResourceDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentErrorObject: errorLogs[0],
                            currentPointer: 0,
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyResourceDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                }
                else {
                    let updateResourceDetailsArray = this.state.updateResourceDetailsArray;
                    importProgressSummary['failed'] += 1;
                    importPointer['status'] = 'failed';
                    updateResourceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                    importPointer['loading'] = false;

                    this.setState({
                        updateResourceDetailsArray: updateResourceDetailsArray,
                        importProgressSummary: importProgressSummary,
                        importPointer: importPointer,
                        currentPointer: 0,
                    }, () => {

                        if (isRetry != "true") {

                            this.apiCallToImportVerifyResourceDetails(rowIndex + 1, importProgressSummary, isRetry);
                        }
                    })

                }
            }

        } else {
            this.setState({
                loadingImportProcess: false
            })
        }
    }

    // API CALL TO IMPORT UPDATE RESOURCE DATA
    apiCallToUpdateResourceDetails = async (rowIndex = 0) => {

        if (rowIndex < this.state.updateResourceDetailsArray.length) {
            let resourceData = this.state.updateResourceDetailsArray[rowIndex];

            let accessionSeriesName = resourceData['Accession Series*'] ? Base64.encode(resourceData['Accession Series*']) : "";
            let accessionNumber = resourceData['Accession Number*'] ? Base64.encode(resourceData['Accession Number*']) : "";
            let FormattedAccessionDate = resourceData['Accession Date']
                ? new Date(resourceData['Accession Date']).toISOString().split('T')[0] // Convert to ISO format and take the date part
                : "";
            let accessionDate = FormattedAccessionDate ? Base64.encode(FormattedAccessionDate) : "";
            let callNumber = resourceData['Call Number'] ? Base64.encode(resourceData['Call Number']) : "";
            let titleName = resourceData['Title*'] ? Base64.encode(resourceData['Title*']) : "";
            let authorName = resourceData['Author*'] ? Base64.encode(resourceData['Author*']) : "";
            let volumeName = resourceData['Resource Volume'] ? Base64.encode(resourceData['Resource Volume']) : "";
            let editionName = resourceData['Resource Edition'] ? Base64.encode(resourceData['Resource Edition']) : "";
            let resourceLanguageName = resourceData['Resource Language*'] ? Base64.encode(resourceData['Resource Language*']) : "";
            let publisherName = resourceData['Publisher*'] ? Base64.encode(resourceData['Publisher*']) : "";
            let NoOfPages = resourceData['Number of Pages'] ? Base64.encode(resourceData['Number of Pages']) : "";
            let preliminaryPages = resourceData['Number of Preliminary Pages'] ? Base64.encode(resourceData['Number of Preliminary Pages']) : "";
            let categoryName = resourceData['Resource Category*'] ? Base64.encode(resourceData['Resource Category*']) : "";
            let yearOfPublication = resourceData['Year of Publication'] ? Base64.encode(resourceData['Year of Publication']) : "";
            let streamIdName = resourceData['Department'] ? Base64.encode(resourceData['Department']) : "";
            let resourceTypeName = resourceData['Resource Type*'] ? Base64.encode(resourceData['Resource Type*']) : "";
            let translatorName = resourceData['Translator Name'] ? Base64.encode(resourceData['Translator Name']) : "";
            let isTranslated = resourceData['Translated'] ? Base64.encode(resourceData['Translated']) : Base64.encode("Yes");
            let keywordName = resourceData['Search Keyword'] ? Base64.encode(resourceData['Search Keyword']) : "";
            let locationName = resourceData['Location'] ? Base64.encode(resourceData['Location']) : "";
            let isbnNumber = resourceData['ISBN Number'] ? Base64.encode(resourceData['ISBN Number']) : "";
            let resourceConditionName = resourceData['Resource Condition'] ? Base64.encode(resourceData['Resource Condition']) : Base64.encode("Good");
            let invoiceNumber = resourceData['Invoice/Bill No.'] ? Base64.encode(resourceData['Invoice/Bill No.']) : "";
            let priceData = resourceData['Price'] ? Base64.encode(resourceData['Price']) : "";
            let discountData = resourceData['Discount (in %)'] ? Base64.encode(resourceData['Discount (in %)']) : "";
            let resourceStatus = resourceData['Resource Status'] ? Base64.encode(resourceData['Resource Status']) : "";

            let requestData = {
                "iid": this.props.resourceSearchIID, // config.institute_id,
                "facultyId": config.faculty_id,
                "accessionseriesid": accessionSeriesName,
                "accessionnumber": accessionNumber,
                "accession_date": accessionDate,
                "callNumber": callNumber,
                "title": titleName,
                "author": authorName,
                "volume": volumeName,
                "edition": editionName,
                "resource_lang": resourceLanguageName,
                "publisherName": publisherName,
                "number_of_pages": NoOfPages,
                "preliminarypages": preliminaryPages,
                "resourceCategoryName": categoryName,
                "yearOfPublication": yearOfPublication,
                "stream_id": streamIdName,
                "resource_type": resourceTypeName,
                "translatorName": translatorName,
                "Translated": isTranslated,
                "keyword": keywordName,
                "location": locationName,
                "isbn_number": isbnNumber,
                "resource_condition": resourceConditionName,
                "invoiceno": invoiceNumber,
                "price": priceData,
                "discount": discountData,
                "resource_status": resourceStatus,
                "iidArray": this.props.iidArray.iidArray
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'LibraryUpdateMultipleResourceDetails',
                requestData,
                "/api/library/instructor.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToUpdateResourceDetails(rowIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == 'success') {
                        // toast.success(apiResult.message, {
                        //     position: "top-right",
                        //     autoClose: 2000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        // });
                        this.apiCallToUpdateResourceDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'success',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToUpdateResourceDetails(rowIndex + 1);
                        // });
                    }
                    else {
                        toast.warn(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.apiCallToUpdateResourceDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'warning',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToUpdateResourceDetails(rowIndex + 1);
                        // });
                    }
                }
                else {
                    toast.error('Something went wrong while updating resource. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToUpdateResourceDetails(rowIndex + 1);
                    // this.setState({
                    //     successModal: true,
                    //     successModalType: 'error',
                    //     successMessage: 'Something went wrong while updating resource. Please try again later.'
                    // }, () => {
                    //     this.apiCallToUpdateResourceDetails(rowIndex + 1);
                    // });
                }
            }

        } else {
            this.setState({
                loadingImportResourceProcess: false,
                isImportButtonDisabled: true
            })
            // common success message
            toast.success("Resource data updated successfully.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    checkImportStatus = () => {
        return this.state.updateResourceDetailsArray.some((item, index) => item.importStatus == 'success')
    }

    checkImportTabProgress = (index) => {
        if (index == 0) {
            return this.state.validations['isVerified']
        } else if (index == 1) {
            return this.checkImportStatus()
        }
    }

    render() {
        return (
            <>
                {this.importUpdateResourceModal()}
                <div id="exportList"></div>
                <SuccessModal
                    successModal={this.state.successModal}
                    successModalType={this.state.successModalType}
                    successMessage={this.state.successMessage}
                    closeSuccessModal={this.closeSuccessModal}
                />

            </>
        )
    }
}

const ProgressBar = (props) => {
    const { bgcolor, completed, failed, pending, total } = props;

    let pendingProgressWidth = (pending / total) * 100;
    let completedProgressWidth = (completed / total) * 100;
    let failedProgressWidth = (failed / total) * 100;


    const containerStyles = {
        // height: 15,
        width: '100%',
        backgroundColor: "#e0e0de",
        margin: '0.2em 0',
        display: 'flex',

    }

    const fillerStyles = {
        height: '100%',
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: 'width 1s ease-in-out',
    }

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    }
    const completedProgress = {
        width: `${completedProgressWidth.toFixed(2)}%`,
        backgroundColor: 'green'
    }


    const failedProgress = {
        width: `${failedProgressWidth.toFixed(2)}%`,
        backgroundColor: 'tomato'
    }

    const pendingProgress = {
        width: `${pendingProgressWidth.toFixed(2)}%`,
        backgroundColor: 'orange'
    }
    return (
        <div style={containerStyles}>
            {
                total > 0 && (<>
                    <div style={{ ...fillerStyles, ...completedProgress }}>
                        <span style={labelStyles}>{`${completedProgressWidth.toFixed(2)}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...failedProgress }}>
                        <span style={labelStyles}>{`${failedProgressWidth.toFixed(2)}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...pendingProgress }}>
                        <span style={labelStyles}>{`${pendingProgressWidth.toFixed(2)}%`}</span>
                    </div>
                </>)
            }

        </div>
    );
};


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET admin DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};

export default connect(mapStateToProps)(ImportBulkUpdateResources);